<ng-template #summaryTableLabel>
  <div class="summary-table-label" [class.summary-table-label--bold]="isBold">
    <ng-content></ng-content>
  </div>
</ng-template>
